(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atom-blog-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-hub-section]');
    if (!section) return;

    const tabs = section.querySelector('[data-hub-tabs]');
    if (!tabs) return;

    const grid     = section.querySelector('[data-hub-grid]');
    const buttons  = Array.from(tabs.querySelectorAll('[data-hub-filter]'));
    const cards    = grid ? Array.from(grid.querySelectorAll('[data-hub-type]')) : [];

    if (!buttons.length || !cards.length) return;

    const filter = (activeButton) => {
      const value = activeButton.dataset.hubFilter;

      buttons.forEach((btn) => {
        const active = btn === activeButton;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      cards.forEach((card) => {
        const match = value === 'all' || card.dataset.hubType === value;
        card.classList.toggle('is-hidden', !match);
      });
    };

    tabs.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-hub-filter]');
      if (!btn) return;
      filter(btn);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atom-blog-index"]) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-xpb-blog]');

    sections.forEach((section) => {
      const tabs = section.querySelector('[data-xpb-tabs]');
      if (!tabs) return;

      const buttons = Array.from(tabs.querySelectorAll('[data-xpb-filter]'));
      const cards = Array.from(section.querySelectorAll('[data-xpb-card]'));
      const feature = section.querySelector('[data-xpb-feature]');
      const articles = Array.from(section.querySelectorAll('[data-xpb-article]'));
      const heading = section.querySelector('#xpb-grid-heading');
      const status = section.querySelector('[data-xpb-status]');

      const matches = (article, filter) => {
        if (filter === 'all') return true;
        return ` ${article.dataset.xpbTags || ''} `.includes(` ${filter} `);
      };

      const formatLabel = (button) => {
        const clone = button.cloneNode(true);
        const count = clone.querySelector('.xpb-tab__count');
        if (count) count.remove();
        return clone.textContent.trim() || 'Articles';
      };

      const hydrateCounts = () => {
        buttons.forEach((button) => {
          const filter = button.dataset.xpbFilter;
          const count = articles.filter((article) => matches(article, filter)).length;
          const countNode = button.querySelector('[data-xpb-count]');
          if (countNode) countNode.textContent = String(count);
        });
      };

      const render = (button) => {
        const filter = button.dataset.xpbFilter;
        let visibleCards = 0;

        buttons.forEach((tab) => {
          const active = tab === button;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        cards.forEach((card) => {
          const visible = matches(card, filter);
          card.classList.toggle('is-hidden', !visible);
          if (visible) visibleCards += 1;
        });

        const featureVisible = feature ? matches(feature, filter) : false;
        if (feature) feature.hidden = !featureVisible;

        if (heading) heading.textContent = filter === 'all' ? 'All articles' : formatLabel(button);
        if (status) {
          status.textContent = featureVisible
            ? `Showing ${visibleCards} + 1 featured`
            : `Showing ${visibleCards}`;
        }
      };

      hydrateCounts();

      tabs.addEventListener('click', (event) => {
        const button = event.target.closest('[data-xpb-filter]');
        if (!button) return;
        render(button);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
